<template>
    <div class="news_detail">
        <div class="container">
            <div class="news_column d-flex">
                <div class="news_column_part">
                    <NewsTitle :title="content['title']" :lang="content['categories']" :country="content['categories']"/>
                </div>

                <div class="news_column_part">
                    <div class="news_content" v-animate-child="'fade-in'">
                        <div v-html="cont"></div>
                    </div>
                    <div class="back d-md-none"><a href="/global/news/">Back to all news</a></div>
                </div>
            </div>
        </div>
        <NewsBottom :prev-news="prevNews" :next-news="nextNews"/>
    </div>
</template>

<script>
    import NewsBottom from "./NewsBottom";
    import NewsTitle from "./NewsTitle";
    import Configuration from "../../utils/configuration";

    export default {
        name: 'NewsDetailContent',
        components: { NewsBottom, NewsTitle },
        data() {
            return {
                id: this.$route.query.id ? this.$route.query.id : 0,
                content: {},
                cont: "",
                prevNews: {},
                nextNews: {},
            }
        },
        created() {
            this.axios.get('/global-news/news.json').then( res => {
                for(let i=0; i<res.data.length; i++) {
                    if(res.data[i].id == this.id) {
                        this.content = res.data[i]
                        this.cont = this.unescape(res.data[i].content[0])
                        this.prevNews = res.data[i-1]
                        this.nextNews = res.data[i+1]
                    }
                }
            })
        },
        methods: {
            unescape(html) {
                return html
                .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, "\"")
                .replace(/&#39;/g, "\"")
                .replace(/<br>/g, '');
            }
        },
        metaInfo() {
          if ('meta' in this.content)
            return {
              title: this.content.meta.title,
              meta: [
                {
                  property: 'description',
                  content: this.content.meta.description,
                  vmid: 'description'
                },
                {
                  property: 'og:title',
                  content: this.content.meta.title,
                  vmid: 'og:title'
                },
                {
                  property: 'og:url',
                  content: this.content.meta.url,
                  vmid: 'og:url'
                },
                {
                  property: 'og:type',
                  content: Configuration.site.meta.og_type,
                  vmid: 'og:type'
                },
                {
                  property: 'og:site_name',
                  content: Configuration.site.meta.og_site_name,
                  vmid: 'og:site_name'
                }
              ]
            }
        }
    }
</script>

<style lang="scss">
    .news_detail {
        .news_list {
            margin-bottom: 25px;
            padding-left: 0;

            > li {
                list-style: none;
                position: relative;

                &:first-child {
                    padding-left: 40px;

                    &::before {
                        content: '';
                        display: block;
                        width: 20px;
                        height: 12px;
                        background: url('../../assets/news/flag/japan-flag.svg') no-repeat center center;
                        background-size: cover;
                        position: absolute;
                        top: 6px;
                        left: 0;
                    }
                }

                &.Vietnam::before {
                    background: url('../../assets/news/flag/vienna-flag.svg') no-repeat center center;
                    background-size: cover;
                }

                &.China::before {
                    background: url('../../assets/news/flag/chinese-flag.svg') no-repeat center center;
                    background-size: cover;
                }

                &.Taiwan::before {
                    background: url('../../assets/news/flag/taiwan-flag.svg') no-repeat center center;
                    background-size: cover;
                }

                &.Thailand::before {
                    background: url('../../assets/news/flag/thailand-flag.svg') no-repeat center center;
                    background-size: cover;
                }

                &.Malaysia::before {
                    background: url('../../assets/news/flag/malaysia-flag.svg') no-repeat center center;
                    background-size: cover;
                }

                &:not(:last-child) {
                    padding-right: 18px;
                    margin-right: 17px;

                    &::after {
                        content: '';
                        display: block;
                        height: 16px;
                        border-right: 2px solid #000000;
                        position: absolute;
                        top: calc(50% - 8px);
                        right: 0;
                    }
                }
            }
        }
        .back {
            font-size: 20px;
            font-weight: 500;
            padding-left: 40px;
            position: fixed;
            bottom: 281px;
            transition: all 0.3s;
            z-index: 99;

            &::before {
                content: '';
                display: block;
                width: 18px;
                height: 13px;
                background: url('../../assets/news/ico-back.svg') no-repeat center center;
                background-size: cover;
                position: absolute;
                left: 0;
                top: 9px;
            }

            &:hover {
                padding-left: 48px;
            }

            &:hover::before {
                background: url('../../assets/news/ico-back_on.svg') no-repeat center center;
                background-size: cover;
            }

            a:hover {
                color: #000000;
            }
        }
    }
    @media screen and (max-width: 767px) {
        .news_detail {
            .back {
                position: relative;
                bottom: unset;
                left: unset;
            }
        }
    }

    .image {
        width: 100%;
        height: auto;
    }

    .news_column {
        justify-content: space-between;
        margin-bottom: 160px;
        position: relative;
    }

    .news_column_part img {
        width: 100%;
        height: auto;
    }

    .news_column_part {
        &:first-child {
            width: 40.5%;
        }

        &:last-child {
            width: 49.4%;
        }
    }

    .news_content {
        margin-top: 52.03px;
        p {
            line-height: 1.875;
            word-break: break-all;

            &:not(:last-child) {
                margin-bottom: 30px;
            }
        }
    }

    .news_column_image {
        margin: 44px 0;
    }

    @media screen and (max-width: 767px) {
        .news_column {
            display: block !important;
            margin-bottom: 70px;
        }

        .news_column_part:first-child {
            width: 100%;
            margin-bottom: 92px;
        }

        .news_column_part:last-child {
            width: 100%;
        }

        .news_content {
            margin-bottom: 200px;
        }
    }
</style>
